import { h, Component } from 'preact';
// import Store from 'store/store';
// import * as actions from 'store/actions';
import { isDemoTicketing } from 'store/ticketingPublic';
import { getCopy } from 'utils/copy';
import { accessNested, isObject, displayWhen } from 'utils/utils';
import { Link } from 'components/core/link/link';
import PaymentLoader from 'components/shared/theaters/ticketing/gateways/paymentLoader';
import s from 'components/shared/theaters/ticketing/gateways/vantivPaymentGateway/vantivPaymentGateway.sss';


const VANTIV_URL_DEV = 'https://certtransaction.hostedpayments.com/?TransactionSetupID=%token%';
const VANTIV_URL_PROD = 'https://transaction.hostedpayments.com/?TransactionSetupID=%token%';
const VANTIV_URL = isDemoTicketing() ? VANTIV_URL_DEV : VANTIV_URL_PROD;

const VANTIV_IFRAME_LOADING_TIME_MS = 3500;

const VantivLogo = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 460 120" {...props}>
		<path d="M341.16 1.875a14.107 14.107 0 0 0-14.107 14.107A14.107 14.107 0 0 0 341.16 30.09a14.107 14.107 0 0 0 14.108-14.108A14.107 14.107 0 0 0 341.16 1.875zm-59.023 10.871v24.168h-7.754v18.889h7.754v58.785h25.136V55.803h13.213V36.914h-13.213V12.746h-25.136zM139.9 33.29a50.082 50.082 0 0 0-1.744.01c-12.738.299-25.713 5.38-33.289 12.014l10.86 14.457c16.213-11.483 35.228-11.461 35.228 6.693h-16.351c-60.223 0-33.27 76.552 17.585 40.28v7.827h22.694V72.713c0-29.133-16.995-39.219-34.983-39.424zm97.782.49c-8.53.046-17.462 3.384-24.467 10.705v-7.877h-25v78.036h25V71.07c2.402-22.537 28.086-20.527 28.086-2.84v46.34h24.875v-54.8c0-16.167-13.629-26.07-28.494-25.99zm90.8 2.56v78.126h25.178V36.34h-25.178zm28.375.016l33.967 77.891h23.928l33.986-77.89h-27.097L403.365 83.81l-18.422-47.456h-28.086zM11.87 36.74l33.967 77.893h23.928L103.75 36.74H76.652L58.377 84.197 39.955 36.74H11.87zM134.33 81.473h15.893v7.01c0 9.29-14.97 13.406-21.92 9.978-6.95-3.428-5.293-16.988 6.027-16.988zM439.291 96.33c-4.87 0-8.834 3.963-8.834 8.834 0 4.87 3.963 8.832 8.834 8.832 4.87 0 8.832-3.961 8.832-8.832 0-4.87-3.961-8.834-8.832-8.834zm0 1.25a7.574 7.574 0 0 1 7.582 7.584 7.572 7.572 0 0 1-7.582 7.582 7.574 7.574 0 0 1-7.584-7.582 7.576 7.576 0 0 1 7.584-7.584zm-2.969 2.72v9.718h1.807v-3.797h.773c.18 0 .313.025.403.074.094.05.18.132.256.248l2.043 3.111a.824.824 0 0 0 .275.268.81.81 0 0 0 .402.096h1.627l-2.433-3.588a1.79 1.79 0 0 0-.59-.559c.34-.107.642-.25.906-.43.269-.179.493-.387.672-.625.184-.237.322-.501.416-.793.098-.29.148-.6.148-.927 0-.412-.071-.789-.214-1.13a2.174 2.174 0 0 0-.667-.886c-.3-.246-.687-.436-1.162-.57-.47-.14-1.036-.21-1.699-.21h-2.963zm1.807 1.4h1.156c.668 0 1.162.131 1.485.396.327.264.49.642.49 1.134 0 .247-.04.472-.121.678-.081.206-.204.387-.37.54-.16.147-.37.264-.624.349-.251.085-.547.127-.887.127h-1.13v-3.225z" />
	</svg>
);


export default class VantivPaymentGateway extends Component {

	constructor(props) {
		super(props);

		this.state = {
			loading: true
		};
	}

	componentDidMount() {
		const that = this;
		setTimeout(() => that.setState({ loading: false }), VANTIV_IFRAME_LOADING_TIME_MS);
	}

	render(props, { loading }) {
		const {
			ticketing, // Object - the ticketing state
			theater
		} = props;

		const theaterName = accessNested(ticketing, 'meta.theaterName');

		const { paymentData } = ticketing;
		const token = isObject(paymentData) ? paymentData.token : paymentData;

		return (
			<div class={s.container}>
				<header class={s.header}>
					<h2 class={s.title}>{getCopy('PROVIDE_PAYMENT_INFO', { THEATER_NAME: theaterName })}</h2>
				</header>
				<div class={s.iframeWrapper}>
					<iframe
						src={VANTIV_URL.replace('%token%', token)}
						class={s.iframe}
						name="vantivIframe"
						style={displayWhen(!loading)}
						ref={$ref => this.$iframe = $ref}
					/>
					<PaymentLoader color="#585759" style={displayWhen(loading)}>
						<VantivLogo />
					</PaymentLoader>
				</div>
				<footer class={s.footer}>
					<p>
						<svg class={s.lockIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
							<path d="M50.164 13.896c-12.817 0-23.292 10.446-23.342 23.252v6.956h-1.029a4.283 4.283 0 0 0-4.293 4.294v33.414a4.283 4.283 0 0 0 4.293 4.292h48.414a4.283 4.283 0 0 0 4.293-4.292V48.398a4.283 4.283 0 0 0-4.293-4.294h-.703v-6.956c-.05-12.806-10.523-23.252-23.34-23.252zm0 7.5c8.763 0 15.789 7 15.838 15.752v6.956H34.324v-6.956a15.785 15.785 0 0 1 15.84-15.752zM50 54.426a6.045 6.045 0 0 1 6.045 6.046 6.045 6.045 0 0 1-3.945 5.664l.9 7.152h-6l.9-7.154a6.045 6.045 0 0 1-3.945-5.662A6.045 6.045 0 0 1 50 54.427z" />
						</svg>
						<span class={s.encryption}>SSL Encryption</span>
						<span>powered by</span>
						<Link class={s.vantivLogo} target="_blank" href="https://www.vantiv.com/" renderCustomChild>
							<VantivLogo />
						</Link>
					</p>
				</footer>
			</div>
		);
	}

}
